import { render } from "./Flag.vue?vue&type=template&id=8c6839dc&scoped=true"
import script from "./Flag.vue?vue&type=script&lang=js"
export * from "./Flag.vue?vue&type=script&lang=js"

import "./Flag.vue?vue&type=style&index=0&id=8c6839dc&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c6839dc"]])

export default __exports__